export default function TrackRecordSection() {
  const stats = [
    {
      number: '200+',
      label: 'Rental Properties Purchased',
      description: 'We\'ve successfully purchased over 200 tenant occupied properties throughout El Paso and surrounding areas.',
      icon: 'ri-building-fill'
    },
    {
      number: '$120M+',
      label: 'Total Transaction Value',
      description: 'Our portfolio represents more than $120 million in rental property acquisitions, demonstrating our financial strength.',
      icon: 'ri-money-dollar-circle-fill'
    },
    {
      number: '3,200+',
      label: 'Total Units Acquired',
      description: 'From single-family rentals to large apartment complexes, we\'ve purchased properties with over 3,200 individual units.',
      icon: 'ri-home-4-fill'
    },
    {
      number: '100%',
      label: 'Title Company Closings',
      description: 'Every single transaction is processed through a reputable title company—no exceptions. Your protection is guaranteed.',
      icon: 'ri-shield-check-fill'
    },
    {
      number: '12 Days',
      label: 'Average Closing Time',
      description: 'Our average time from offer acceptance to closing is just 12 days, though we can close faster or slower based on your needs.',
      icon: 'ri-time-fill'
    },
    {
      number: '98%',
      label: 'Seller Satisfaction Rate',
      description: 'Nearly all sellers who work with us report being satisfied or very satisfied with the process and outcome.',
      icon: 'ri-star-fill'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Our Proven Track Record
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Numbers don't lie. Our track record speaks to our experience, reliability, and commitment to buying tenant occupied real estate professionally and ethically.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="bg-white/5 backdrop-blur-sm p-8 rounded-xl border border-white/10 hover:bg-white/10 transition-all duration-300"
            >
              <div className="w-16 h-16 bg-teal-600/20 rounded-lg flex items-center justify-center mb-6">
                <i className={`${stat.icon} text-teal-400 text-3xl`}></i>
              </div>
              <div className="text-5xl font-bold text-teal-400 mb-3">{stat.number}</div>
              <h3 className="text-xl font-bold mb-3">{stat.label}</h3>
              <p className="text-gray-300 leading-relaxed">{stat.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-white/10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">Why Our Track Record Matters</h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                When you sell tenant occupied property, you need a buyer with proven experience and financial capability. Our track record demonstrates that we have the resources, expertise, and systems to handle any rental property transaction—from small single-family homes to large apartment complexes.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                We've worked with hundreds of landlords facing every imaginable situation: difficult tenants, deferred maintenance, complex lease agreements, multiple units, and more. This experience means we can move quickly, handle complications professionally, and close on time.
              </p>
              <p className="text-gray-300 leading-relaxed">
                Most importantly, our 100% title company closing rate means you're always protected. We never cut corners or take shortcuts that could put you at risk.
              </p>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/73c68698c2b53892cf0b2f0668a3b0d5.jpg"
                alt="Rental Property Track Record"
                className="w-full h-auto rounded-lg shadow-2xl object-cover"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <a 
            href="tel:+1-915-206-5814"
            className="inline-flex items-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call (915) 206-5814 to Discuss Your Property
          </a>
        </div>
      </div>
    </section>
  );
}